<span *ngIf="type !== 6">{{ type | vehicleIndicatorTypeUnit }}</span>
<span *ngIf="type === 6">&#8451;</span>
<span *ngIf="type === 20">&#176;</span>
<span *ngIf="type === 24">m/s<sup>2</sup></span>